import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { formatPhoneNumber } from '@/utils/formatters'
import Address from '@/components/Address'
import { Input } from '@/components/ui'
import EmailLink from '@/components/EmailLink'

export default ({ item, label = "Propriétaire", index }) => (
    <div className="relative">
      <Input.Display label={`${label} ${index + 1}`}>
        <div className="flex items-center">
          <span className="uppercase">{item.nom_complet}</span>
          <div className="dropdown dropdown-hover">
            <div tabIndex={0} role="button" className="btn btn-circle btn-ghost btn-xs m-1"><InformationCircleIcon className="size-5" /></div>
            <div tabIndex={0} className="card dropdown-content w-80 bg-base-100 rounded-box z-1 p-2 shadow-sm">
              <div tabIndex={0} className="card-body">
                <h3 className="card-title font-bold text-sm text-gray-600">Détails du {label.toLowerCase()}</h3>
                { item.civilite !== "SCI" && (
                  <Input.Display label="Téléphone" value={item.telephone ? formatPhoneNumber(item.telephone) : 'Non renseigné'} 
                    className="flex flex-wrap items-center"
                  />
                )}
                { item.civilite !== "SCI" && (
                  <Input.Display label="Email"
                    className="flex flex-wrap items-center"
                  >
                    <EmailLink email={item.email} />
                  </Input.Display>
                )}
                
                <Input.Display label="Adresse" 
                  className="flex flex-wrap items-center"
                >
                  <Address data={item} />
                </Input.Display>
              </div>
              <div className="justify-end card-actions">
                <a href={`/contacts/${item.contact_id || item.id}`} className="btn">Voir la fiche</a>
              </div>
              { item.contacts?.length > 0 && item.contacts.map(
                (contact, index) => (
                <div key={index}>
                  <div className="divider mt-0"></div>
                  <div className="card">
                    <div className="card-body pt-0">
                      <h3 className="card-title text-sm">
                        <Input.Display label="Contact"
                          className="flex flex-wrap items-center"
                        >
                          <span className="uppercase">{contact.nom_complet}</span>
                        </Input.Display>
                      </h3>

                      <Input.Display label="Téléphone" value={contact.telephone ? formatPhoneNumber(contact.telephone) : 'Non renseigné'}
                        className="flex flex-wrap items-center"
                      />

                      <Input.Display label="Email"
                        className="flex flex-wrap items-center"
                      >
                        <EmailLink email={contact.email} />
                      </Input.Display>
                    </div>
                  </div>
                </div>)
              )}
            </div>
          </div>
        </div>
      </Input.Display>
    </div>
)